export function formatItemsSummary(items) {
  if (!items || items.length === 0) return "";
  const first = items[0];
  const firstName = first.dosage ? `${first.productName} ${first.dosage}` : first.productName;
  const remaining = items.length - 1;
  return remaining === 0 ? firstName : `${firstName} + ${remaining} more`;
}

const TONE_MAP = {
  delivered: "success",
  shipped: "info",
  confirmed: "info",
  readyForPickup: "info",
  payment_pending: "attention",
  cancelled: "critical",
};

export function getStatusBadgeTone(status) {
  return TONE_MAP[status] || "info";
}

export function getStatusLabelKey(status) {
  return `peptides.orderStatus.${status}`;
}

export function filterAndAggregateForPatient(allOrders, patientId) {
  const matches = (allOrders || []).filter((o) => o.assignedPatientId === patientId && o.status !== "draft");
  const sorted = [...matches].sort((a, b) => String(b.dateOfService || "").localeCompare(String(a.dateOfService || "")));
  const lifetimeCents = matches.filter((o) => o.status !== "cancelled").reduce((sum, o) => sum + (o.totalCents || 0), 0);
  return {
    orders: sorted,
    totalCount: sorted.length,
    lifetimeCents,
    lastOrderedAt: sorted[0]?.dateOfService || null,
  };
}
